import { colors } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { Link } from '~/components/Link';
import {
  ContentContainer,
  Kicker,
  SectionH2,
  SectionHeadRow,
} from '~/components/HomepageV3/styles';
import { useCategories } from '~/hooks/useCategories';
import { useSuggestions } from '~/hooks/useSuggestions';
import { IndustryTable } from '~/components/IndustryTable';
import { Category } from '@mui/icons-material';
import { CategoryRow } from '~/components/CategoryRow';

function useTechCategories() {
  const categories = useCategories();
  const suggestions = useSuggestions();

  const CATEGORY_IDS = [80, 64, 70, 37, 29, 87, 57, 8];

  return CATEGORY_IDS.flatMap((categoryId) => {
    const category = categories?.find((c) => c.id === categoryId);
    if (!category) {
      return [];
    }

    const topSuggestions = suggestions
      .filter((s) => s.categories_id === categoryId)
      .sort((a, b) => b.total - a.total)
      .slice(0, 10);

    return [{ category, topSuggestions }];
  });
}

export const TechCategorySection = () => {
  const techCategories = useTechCategories();
  return (
    <ContentContainer sx={{ py: 12 }}>
      <SectionHeadRow>
        <div>
          <Kicker>Browse by category</Kicker>
          <SectionH2>Every category. Every vendor.</SectionH2>
        </div>
        <Link href="/technologies" className="design-link" underline="hover">
          Browse all categories
          <EastIcon sx={{ fontSize: 14, ml: 0.5 }} />
        </Link>
      </SectionHeadRow>

      <IndustryTable
        title="Popular Categories"
        color={colors.blue[400]}
        icon={<Category color="white" />}>
        {techCategories.map(({ category, topSuggestions }) => {
          return (
            <CategoryRow
              key={category.id}
              id={category.id}
              name={category.name}
              total={category.total}
              color={colors.blue[400]}
              reports={topSuggestions}
            />
          );
        })}
      </IndustryTable>
    </ContentContainer>
  );
};
